import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      aboutPrefix: '<span class="t-500">About: </span>',
      researchGroupPrefix: '<span class="t-500">Research Group: </span>',
      publicationPrefix: '<span class="t-500">Publication: </span>',
      projectPrefix: '<span class="t-500">Project: </span>',
      clinicalTrialPrefix: '<span class="t-500">Clinical Trial: </span>'
    }
  },
  computed: {
    fullName () {
      if (this.highlights && this.highlights.full_name) return this.highlights.full_name[0]
      if (this.highlights && this.highlights.initial_name) return this.highlights.initial_name[0]
      return this.data.full_name
    },
    about () {
      if (!this.isEmpty(this.researchGroupDescription)) {
        return `${this.researchGroupPrefix} ${this.researchGroupDescription}`
      } else if (!this.isEmpty(this.abstractDescription)) {
        return `${this.publicationPrefix} ${this.abstractDescription}`
      } else if (!this.isEmpty(this.projectDescription)) {
        return `${this.projectPrefix} ${this.projectDescription}`
      } else if (!this.isEmpty(this.clinicalTrialDescription)) {
        return `${this.clinicalTrialPrefix} ${this.clinicalTrialDescription}`
      } else if (!this.isEmpty(this.aboutDescription)) {
        return `${this.aboutPrefix} ${this.aboutDescription}`
      }

      return (this.data.about) ? `${this.aboutPrefix} ${this.stripTags(this.data.about)}` : ''
    },
    researchGroups () {
      return !this.isEmpty(this.data.research_groups) ? this.data.research_groups.filter(rg => rg.slug_values && rg.slug_values.length > 0).slice(0, 4) : []
    },
    organisations () {
      return !this.isEmpty(this.data.organisations) ? this.data.organisations.slice(0, 4) : []
    }
  }
}
